var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagIcon = function SvgTagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.925 18.475a1.8 1.8 0 0 1-2.548 0l-3.853-3.85a1.8 1.8 0 0 1 0-2.548l6.498-6.494a2 2 0 0 1 1.414-.586h3.565a2 2 0 0 1 2.001 2v3.56a2 2 0 0 1-.585 1.415z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M21.004 7.998v3.799a2 2 0 0 1-.586 1.415l-5.665 5.664"
  })));
};
export { SvgTagIcon as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNjQ1MGJkZjliNDM3NjllMzAyYzc2NWU4NWQ3ZTRlMmEuc3ZnIjs=";